import * as React from 'react';
import './LocalSpinner.css';

export class LocalSpinner extends React.Component {
  render() {
    return (
      <span className="LocalSpinner" />
    );
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LocalSpinner/LocalSpinner.tsx